/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Mode_ChatInputs */



/**
* | output |
* | --- |
* | "Chat" |
*
* @param {Practice_Session_Mode_ChatInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_mode_chat = /** @type {((inputs?: Practice_Session_Mode_ChatInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Mode_ChatInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Chat")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chat")
	return /** @type {LocalizedString} */ ("Chat")
});